<template>
  <div id="user-edit-tab-info" class="mt-0" style="margin-top: 0px !important;">
    <div id="studentLogbokClassLoadingDiv" class="vs-con-loading__container">
      <div  class="vx-row" >
        <div class="vx-col w-full pt-1" align="right">
          <vs-button v-on:click.prevent="refreshLogbokClasses()" color="danger" type="gradient" icon-pack="feather" icon="icon-rotate-cw" icon-after></vs-button>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col sm:w-full pr-0 w-full mb-2">
          <vs-list>
            <vs-list-item v-for="(result, resultIndex) in results" :key="resultIndex" :title="result.test.name" :subtitle="getDateString(result.created_at)">
              <vs-avatar slot="avatar" :src="result.test.picture" :text="result.test.name" />
              <vs-button class="mr-2" radius color="primary" type="gradient" icon-pack="feather" icon="icon-plus"></vs-button>
            </vs-list-item>
          </vs-list>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import 'flatpickr/dist/flatpickr.css'
import Datepicker from 'vuejs-datepicker';
import flatPickr from 'vue-flatpickr-component'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'
import moduleClassManagement from '@/store/class-management/moduleClassManagement.js'
import { CalendarView, CalendarViewHeader } from "vue-simple-calendar"
import moduleCalendar from '@/store/calendar/moduleCalendar.js'
require("vue-simple-calendar/static/css/default.css")

export default {
  components: {
    vSelect,
    flatPickr,
    Datepicker,
    VuePerfectScrollbar,
     CalendarView,
    CalendarViewHeader,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    results: {
      // type: Array,
      required: true,
    },
  },
  data() {
    return {
      active1: true,
      data_local: JSON.parse(JSON.stringify(this.data)),
    }
  },
  computed: {
    
  },
  methods: {
    getDateString(date) {
      const d = new Date(date);
      const ye = new Intl.DateTimeFormat('en', { year: '2-digit' }).format(d);
      const mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(d);
      const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);
      const ho = ("0" + d.getHours()).slice(-2);
      const mi = ("0" + d.getMinutes()).slice(-2);
      return (`${da}-${mo}-${ye}  ${ho}:${mi}`);
    },
    refreshLogbokClasses() {
      this.$vs.loading({
          container: '#studentLogbokClassLoadingDiv',
          scale: 0.6
      })

      this.fetchStudentResults(this.data_local.id)
    },
    fetchStudentResults(userId) {
      this.$store.dispatch("userManagement/fetchStudentResults", {student_id : userId})
        .then(res => { 
          this.$vs.loading.close('#studentLogbokClassLoadingDiv > .con-vs-loading')
          this.results = res.data
        })
        .catch(err => {
          this.$vs.loading.close('#studentLogbokClassLoadingDiv > .con-vs-loading')
        })
    },
  },
  created() {
    if(!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }
  },
  mounted(){
    this.refreshLogbokClasses()
  }
}
</script>

<style type="text/css">

#createBookingLoadingDiv{
  min-height: 50px !important;
}
.vdp-datepicker .vdp-datepicker__calendar {
    z-index: 60000 !important;
    /*position: relative;*/
    width: 270px;
    border-radius: 5px !important;
}

::-webkit-scrollbar {
    width: 0px;
    background: transparent;
}

</style>